window.Products.Embroidery.DadCap = function() {};
window.Products.Embroidery.DadCap.texturesLoading = false;
window.Products.Embroidery.DadCap.texturesLoaded = 0;
window.Products.Embroidery.DadCap.inherits(window.Products.Embroidery.Embroidery);
window.Products.Embroidery.DadCap.id = 201;
window.Products.Embroidery.DadCap.slug = 'dad-cap';

window.Products.Embroidery.DadCap.prototype.set3dProperties = function (modelViewer) {
	var me = this;

	if(!me.texturesLoading && !me.texturesLoaded){
		me.loadTextures(function(){
			// Remove default lights
			modelViewer.scene.remove(modelViewer.camera_light);
			modelViewer.scene.remove(modelViewer.ambient_light);

			// Add new cool light setup
			hemiLight = new THREE.HemisphereLight( 0xe5f0ff, 0xfff4e5, 0.8 );
			hemiLight.position.set( 0, 50, 0 );
			modelViewer.scene.add( hemiLight );
			modelViewer.ambient_light = hemiLight;

			dirLight = new THREE.DirectionalLight( 0xfff4e5, 1 );
			dirLight.position.multiplyScalar( 30 );
			modelViewer.scene.add( dirLight );
			modelViewer.camera_light = dirLight;

			// Place objects
			modelViewer.object.position.y = 0.02;

			me.loadEnvMap(function(){
				modelViewer.object.children[3].material.envMap = me.envMap;
				modelViewer.object.children[3].material.envMap.mapping = THREE.EquirectangularReflectionMapping;
				modelViewer.object.children[3].material.reflectivity = 0.25;
				modelViewer.object.children[3].material.needsUpdate = true;
				modelViewer.object.children[3].material.envMap.needsUpdate = true;
			});

			// Setup cam and embroidery
			modelViewer.setFixedView('front');
			modelViewer.camera.position.y = 0.2;
			if(!modelViewer.inlab){
				modelViewer.camera.position.z = 0.5;
			}

			// Load texture
			me.updateThreeTexture(modelViewer);

			// Add fake thickness to embroidery object
			var clone = modelViewer.object.children[2].clone();
			modelViewer.scene.add(clone);
			clone.scale.z = 1.005;
			clone.position.y = 0.02;
			clone = modelViewer.object.children[2].clone();
			modelViewer.scene.add(clone);
			clone.scale.z = 0.995;
			clone.position.y = 0.02;
		});
	}
};

window.Products.Embroidery.DadCap.prototype.loadTextures = function(callback){
	var product = this;
	var sources = [
		'textures/snapback_alpha.jpg'
	];
	product.texturesLoading = true;
	product.texturesLoaded = 0;
	product.textures = [];
	sources.forEach(function(src, index) {
		var textureLoader = new THREE.TextureLoader();
		textureLoader.crossOrigin = 'anonymous';

		var texture = textureLoader.load(THREE_JSON_URL + src, function(event){
			product.textures[index] = event;
			product.texturesLoading = false;
			product.texturesLoaded++;
			if(callback && product.texturesLoaded == sources.length){
				callback();
			}
		});
	});
};

window.Products.Embroidery.DadCap.prototype.setThreeControls = function (controls) {
	controls.minDistance = 0.4;
	controls.maxDistance = 0.8;
};

window.Products.Embroidery.DadCap.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[2].material.map = modelViewer.texture;
	modelViewer.object.children[2].material.bumpMap.minFilter = THREE.LinearMipMapLinearFilter;
	modelViewer.object.children[2].material.bumpScale = 0.0005;
	modelViewer.object.children[2].material.map.minFilter = THREE.LinearMipMapLinearFilter;
	modelViewer.object.children[2].material.transparent = true;
	modelViewer.object.children[2].material.alphaMap = modelViewer.product.textures[0];
	modelViewer.object.children[2].material.needsUpdate = true;
};

window.Products.Embroidery.DadCap.prototype.getEditableOptions = function(){
	return ["color", "embroidery-puff"];
};

window.Products.Embroidery.DadCap.prototype.getEditableOptionsNames = function(){
	return [__("create_ns_option.color"), __("create_ns_option.embroidery-puff")];
};

window.Products.Embroidery.DadCap.prototype.getEditableOptionsExtra = function(_option, _container){
	var me = this;
	switch(_option) {
		case "color":
			return '';
		case "embroidery-puff":
			var out = '<hr>';

			var $switch = _container.find(' .switch').find('input');
			$switch.on('click.extra', function(){
				var enabled = $(this).is(':checked');
				if(!enabled) {
					_container.find('input[type=radio]').attr('disabled', true).attr('checked', false);
				} else {
					var first = _container.find('input[type=radio]').attr('disabled', false).get()[0];
					if(first) first.checked = true;
				}
			});

			$('#layer_properties_panel').on('change.extra', '.colors_container input', function(){
				me.updatePuffOption();
			});

			out += '<p class="warning">' + __('create_ns_messages.puffMessage') + '</p>';
			out += '<div id="option_embroidery-puff_colors">' + this.getPuffOption() + '</div>';

			return out;
		default:
			return '';
	}
};

window.Products.Embroidery.DadCap.prototype.getPuffOption = function(){
	var out = '';

	var colors = DesignLab.instance.layerPropertiesManager.getAllColors();
	if(colors.length && DesignLab.instance.lockedScenes.indexOf(DesignLab.instance.scene) == -1){
		$('#container_options_embroidery-puff').find('.switch').find('input').attr('disabled', false);
	} else {
		$('#container_options_embroidery-puff').find('.switch').find('input').attr('disabled', true);
	}

	var enabled = $('#container_options_embroidery-puff').find('.switch').find('input').is(':checked') && !$('#container_options_embroidery-puff').find('.switch').find('input').is(':disabled');

	for(var i = 0; i < colors.length; i++){
		var color = colors[i].substr(1);
		var thumb = '<input type="radio" id="embroidery-puff-' + color + '" name="option_embroidery-puff" value="embroidery-puff-' + color + '"' + (enabled ? '' : 'disabled="disabled"') + '>';
		var label = '<label style="background:#' + color + '" for="embroidery-puff-' + color + '"></label>';
		out += thumb + label;
	}

	return out;
};

window.Products.Embroidery.DadCap.prototype.selectPuffOptionColor = function(color){
	if(!color) return;
	$('#container_options_embroidery-puff').find('.switch').find('input').prop('checked', true);
	$('#option_embroidery-puff_colors').find('#embroidery-puff-' + color.split('#')[1]).prop('checked', true);
};

window.Products.Embroidery.DadCap.prototype.updatePuffOption = function(){
	// Use alternative behavior is the color picked is disabled
	var enabled = $('#container_options_embroidery-puff').find('.switch').find('input').is(':checked');

	if(enabled){
		// Get already selected color
		var checked_id = $('#option_embroidery-puff_colors').find('input:checked').attr('id');

		// Load new colors
		$('#option_embroidery-puff_colors').html(this.getPuffOption());

		// Reselect the same color or select the first one
		if($('#option_embroidery-puff_colors').find('#' + checked_id).length)
			$('#option_embroidery-puff_colors').find('#' + checked_id).first().get()[0].checked = true;
		else if($('#option_embroidery-puff_colors input[type=radio]').get()[0])
			$('#option_embroidery-puff_colors input[type=radio]').get()[0].checked = true;
	} else {
		// Get index of already selected color
		var checked_index = $('#option_embroidery-puff_colors').find('input:checked').index('#option_embroidery-puff_colors input[type=radio]');

		// Load new colors
		$('#option_embroidery-puff_colors').html(this.getPuffOption());

		// Reselect the same index or select the first one
		if($('#option_embroidery-puff_colors input[type=radio]').get()[checked_index])
			$('#option_embroidery-puff_colors input[type=radio]').get()[checked_index].checked = true;
		else if($('#option_embroidery-puff_colors input[type=radio]').get()[0])
			$('#option_embroidery-puff_colors input[type=radio]').get()[0].checked = true;
	}
}; 

window.Products.Embroidery.DadCap.prototype.getOptionsExtra = function(_option){
	var me = this;
	switch(_option) {
		case "color":
			return [];
		case "embroidery-puff":
			var out = [];
			var input = $('#option_embroidery-puff_colors').find('input:checked');
			if(input.length)
				out["embroidery-puff-color"] = '#' + input.val().split('embroidery-puff-')[1];
			return out;
		default:
			return [];
	}
};

window.Products.Embroidery.DadCap.prototype.handleOption = function(e){
	switch(e.data.option){
		case 'color':
			e.data.modelViewer.product.handleColorOption.call(this, e.data.modelViewer);
			break;
		case 'embroidery-puff':
			// Noop 
			break;
		default: 
			// Noop
	}
};

window.Products.Embroidery.DadCap.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var color_1	= me.getColor(color);

	object.children[0].material.color = color_1;
	object.children[1].material.color = color_1;
};

window.Products.Embroidery.DadCap.prototype.getPageFitDimensions = function(variant, scene){
	var data = this.static.preview_data.scenes[scene];
	var width = data.originalWidth;
	var height = data.originalHeight;
	return [width, height];
};

window.Products.Embroidery.DadCap.prototype.getSceneScale = function(_from, _to){
	var ratio = 0.61714285714285714285714285714286; // Had 0.5 before?
	if(_from == _to){
		return 1;
	} else if (_from == 'main'){
		return ratio;
	} else if(_from == 'back'){
		return 1/ratio;
	}
};

window.Products.Embroidery.DadCap.prototype.getColor = function(_name){
	colors = {
		"black": 0x111313,
		"navy": 0x1C1E28,
		"cranberry": 0x7F2230,
		"white": 0xB2B5B8,
		"dark_grey": 0x29292B,
		"pink": 0xB28490,
		"khaki": 0x8F8881,
		"light_blue": 0x849AB2
	};

	return new THREE.Color(colors[_name] || 0x000000);
};